export interface FileWithContents {
  name: string
  encoded: string | ArrayBuffer
}

export async function readFiles(files: File[]) {
  let filesRes = files.map(file => {
    let reader = new FileReader()

    return new Promise<FileWithContents>((resolve, reject) => {
      // Resolve the promise after reading file
      reader.onload = () => {
        if (reader.result)
          resolve({ name: file.name, encoded: reader.result })
        else {
          console.error(`FileReader returned no result`)
          return reject(`FileReader returned no result`)
        }
      }

      reader.onerror = e => {
        console.error(`FileReader failed on file "${file.name}".`, e)
        return reject(`FileReader failed on file "${file.name}".`)
      }

      reader.readAsDataURL(file)
    })
  })

  return await Promise.all(filesRes)
}
